/**
 * on browser bundle, the in-memory caching functionality would not work
 * returning defaults here to avoid bundle size regressions
 */
export const useHeaderInMemoryCacheClient = () => {
  return {
    setHeaderCache: () => void 0,
    validateInMemoryCacheRequest: undefined,
  };
};
